const login = 'login/';
const forgotPass = 'account/reset_password/';
const authCode = 'login/code/';
const userData = 'account/me/';
const confirmPass = 'account/reset_password_confirm/';
const hotlistsList = '/hotlists/';
const entriesImport = '/imports/';
const hotlistFields = '/hotlists/fields/';
const addEntryToHotlist = '/entries/';
const changePass = 'account/set_password/';
const carFilter = 'search/reads/';
const alertFilter = '/search/alerts/';
const galleryReads = 'gallery/reads/';
const phoneManagement = 'account/phone_number/';
const otpCode = '/mfa/request_code/';
const hotlistSearch = '/search/entries/functional_suggest/';
const readsFields = '/reports/reads/fields/';
const alertsFields = '/reports/alerts/fields/';
const reportReads = '/reports/reads/';
const reportAlerts = '/reports/alerts/';
const reportCharts = '/reports/charts/';
const oldAlerts = '/rtv/alerts/';
const dataForParams = '/rtv/filters/fields/';
const savedSearches = '/rtv/filters/';
const searchEntries = '/entries/';
const entryUpdate = '/entries/';
const auditLogs = '/audit/';
const groupsPage = '/groups/';
const permissions = '/permissions/';
const usersList = '/users/';
const organizationsEp = '/organizations/';
const readsStats = '/charts/reads/';
const alertsStats = '/charts/alerts/';
const metaRegions = '/meta/regions/';
const activateUserEp = '/account/activation/';
const resendOtp = 'login/resend_code/';
const userActiveMethods = '/mfa/active_methods/';
const requestChangeMethod = '/mfa/request_code/';
const changeUserMethod = '/mfa/change_primary_method/';
const userSubscriptions = '/subscriptions/';
const analyticsConvoy = 'analytics/convoy/';
const analyticsFrequency = 'analytics/frequency/';
const searchCameras = '/search/cameras/';
const metaVehicleMakes = '/meta/vehicle-makes/';
const rtvActions = '/rtv/actions/';
const archiveItems = '/archive/items/';
const searchPlates = '/search/plates/';

export {
  activateUserEp,
  organizationsEp,
  groupsPage,
  entriesImport,
  permissions,
  usersList,
  login,
  entryUpdate,
  readsStats,
  authCode,
  userData,
  forgotPass,
  confirmPass,
  hotlistFields,
  addEntryToHotlist,
  carFilter,
  phoneManagement,
  otpCode,
  hotlistsList,
  searchEntries,
  changePass,
  hotlistSearch,
  readsFields,
  reportReads,
  oldAlerts,
  dataForParams,
  savedSearches,
  alertsStats,
  reportCharts,
  metaRegions,
  galleryReads,
  resendOtp,
  userActiveMethods,
  requestChangeMethod,
  changeUserMethod,
  userSubscriptions,
  alertFilter,
  reportAlerts,
  alertsFields,
  auditLogs,
  analyticsConvoy,
  analyticsFrequency,
  searchCameras,
  metaVehicleMakes,
  rtvActions,
  archiveItems,
  searchPlates,
};
